import * as React from 'react';
import { Link } from 'react-router';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical, FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { SvgIcon, IconType } from './SvgIcon';

interface Props {
  breadCrumb: any;
}

function BreadCrumb({ breadCrumb }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const moreBreadcrumbs = breadCrumb.slice(0, breadCrumb.length - 2);

  const handleMoreClick = () => {
    setIsOpen(!isOpen);
  };

  const hideOpen = () => {
    setIsOpen(false);
  };

  return (
    <Wrapper>
      <HomeLink to={'/'}>
        <Text>{__('Domov')}</Text>
      </HomeLink>
      <Delimeter key={`dots`}>&#187;</Delimeter>
      <DesktopBreadCrumbs>
        {breadCrumb.map((crumb, i) => {
          if (i === breadCrumb.length - 1) {
            return (
              <TextLink key={`${crumb.name}-${i}`} to={crumb.url}>
                {crumb.name}
              </TextLink>
            );
          }
          return (
            <React.Fragment key={`${crumb.name}-${i}`}>
              <TextLink to={crumb.url}>{crumb.name}</TextLink>
              <Delimeter>&#187;</Delimeter>
            </React.Fragment>
          );
        })}
      </DesktopBreadCrumbs>
      <MobileBreadCrumbs>
        {breadCrumb.map((crumb, i) => {
          if (breadCrumb.length > 2 && i === 0) {
            return (
              <React.Fragment key={`...-${i}`}>
                <MoreWrapper onMouseLeave={hideOpen}>
                  <ClickableText onClick={handleMoreClick}>...</ClickableText>
                  {isOpen && (
                    <MoreBreadCrumbsWrapper>
                      {moreBreadcrumbs.map(b => {
                        return (
                          <MoreTextLink
                            onClick={hideOpen}
                            key={`${crumb.name}-${i}`}
                            to={b.url}
                          >
                            {b.name}
                          </MoreTextLink>
                        );
                      })}
                    </MoreBreadCrumbsWrapper>
                  )}
                </MoreWrapper>
                <Delimeter>&#187;</Delimeter>
              </React.Fragment>
            );
          }

          if (i === breadCrumb.length - 1) {
            return (
              <TextLink key={`${crumb.name}-${i}`} to={crumb.url}>
                {crumb.name}
              </TextLink>
            );
          }

          if (breadCrumb.length > 2 && i < breadCrumb.length - 2) {
            return null;
          }

          return (
            <React.Fragment key={`${crumb.name}-${i}`}>
              <TextLink to={crumb.url}>{crumb.name}</TextLink>
              <Delimeter>&#187;</Delimeter>
            </React.Fragment>
          );
        })}
      </MobileBreadCrumbs>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  margin: 0 auto;
  padding-bottom: ${rem(24)};
  max-width: ${({ theme }) => rem(theme.grid.container.wide)};
  opacity: 0.56;

  ${({ theme }) => theme.mediab.m580`
    margin: 0;
  `}
`;

const DesktopBreadCrumbs = styled(FlexRowCenterVertical)`
  width: 100%;

  // ${({ theme }) => theme.mediab.l925`
  //   margin-top: ${rem(16)};
  // `}

  ${({ theme }) => theme.mediab.m760`
   display: none;
  `}

  a:last-child {
    max-width: initial;
  }
`;

const MobileBreadCrumbs = styled(FlexRowCenterVertical)`
  width: 75%;
  display: none;
  // margin-top: ${rem(16)};

  ${({ theme }) => theme.mediab.m760`
   display: flex;
  `}
`;

const MoreWrapper = styled.div`
  position: relative;
`;

const MoreBreadCrumbsWrapper = styled(FlexCol)`
  position: absolute;
  top: ${rem(16)};
  left: -${rem(24)};
  padding: ${rem(8)};
  border: ${({ theme }) => theme.borders.primary};
  width: ${rem(240)};
  border-radius: ${rem(4)};
  background-color: white;
  z-index: 5;
`;

const HomeLink = styled(Link)`
  display: flex;
  flex-flow: row;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};

  &:hover {
    text-decoration: underline;
  }

  // ${({ theme }) => theme.mediab.l925`
  //   margin-top: ${rem(16)};
  // `}
`;

const linkCss = css`
  font-size: ${rem(12)};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(14)};
  font-family: ${({ theme }) => theme.font.primary};
  margin-right: ${rem(8)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Delimeter = styled(TextP)`
  ${linkCss};
  overflow: initial;

  // ${({ theme }) => theme.mediab.l925`
  //   margin-top: ${rem(16)};
  // `}
`;

const Text = styled(TextP)`
  ${linkCss};

  ${({ theme }) => theme.mediab.s450`
  `}
`;

const TextLink = styled(Link)`
  ${linkCss};
  text-decoration: none;
  max-width: 20ch;

  &:hover {
    text-decoration: underline;
  }
`;

const MoreTextLink = styled(TextLink)`
  margin: ${rem(4)} 0;
`;

const ClickableText = styled(Text)`
  cursor: pointer;
`;

const BoldTextLink = styled(TextLink)`
  font-weight: 600;
`;

export { BreadCrumb };
